import React, { useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showComingSoon, setShowComingSoon] = useState(false);
  const menuRef = useRef(null);

  // Close menu when screen becomes desktop size
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) setMenuOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

 useEffect(() => {
  const handleClickOutside = (event) => {
    if (menuOpen && menuRef.current && !menuRef.current.contains(event.target)) {
      setMenuOpen(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, [menuOpen]);
 
  // Close menu after clicking a link (nice on mobile)
  const handleNavClick = () => setMenuOpen(false);

  return (
    <header className="site-header">
      <div className="navbar-inner">
        {/* Mobile: Hamburger button */}
        <button
          className="hamburger-button"
          aria-label="Open menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((prev) => !prev)}
          type="button"
        >
          ☰
        </button>


        {/* Desktop nav */}
        <nav className="navbar desktop-nav">
          <button
            type="button"
            className="nav-link-button"
            onClick={() => setShowComingSoon(true)}
            style={{ border: "none"}}
          >
            ABA Provider Resources
          </button>
          <NavLink to="/parents" className="nav-link-button" onClick={handleNavClick}>
            Safrly
          </NavLink>
          <NavLink to="/about" className="nav-link-button" onClick={handleNavClick}>
            About Us
          </NavLink>
          <NavLink to="/contact" className="nav-link-button" onClick={handleNavClick}>
            Contact Us
          </NavLink>
        </nav>
      </div>

      {/* Mobile menu dropdown */}
      {menuOpen && (
        <nav className="mobile-menu" ref={menuRef}>
          <div className="mobile-menu-items">
<button
  type="button"
  className="mobile-menu-link"
  onClick={() => {
    setMenuOpen(false);
    setShowComingSoon(true);
  }}
>
  ABA Provider Resources
</button>

            <NavLink
              to="/parents"
              className="mobile-menu-link"
              onClick={handleNavClick}
            >
              Safrly
            </NavLink>

            <NavLink
              to="/about"
              className="mobile-menu-link"
              onClick={handleNavClick}
            >
              About Us
            </NavLink>

            <NavLink
              to="/contact"
              className="mobile-menu-link"
              onClick={handleNavClick}
            >
              Contact Us
            </NavLink>
          </div>
        </nav>
      )}
     {showComingSoon && (
  <div
    onClick={() => setShowComingSoon(false)}
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0, 0, 0, 0.35)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
    }}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        position: "relative",
        backgroundColor: "#f9a8d4",
        borderRadius: "24px",
        padding: "2.5rem 3rem",
        width: "min(420px, 80%)",
        textAlign: "center",
        boxShadow: "0 10px 35px rgba(0, 0, 0, 0.25)",
      }}
    >
      <button
        type="button"
        onClick={() => setShowComingSoon(false)}
        aria-label="Close"
        style={{
          position: "absolute",
          top: "10px",
          right: "16px",
          border: "none",
          background: "none",
          fontSize: "1.75rem",
          cursor: "pointer",
        }}
      >
        ×
      </button>

      <h2
        style={{
          marginTop: 0,
          marginBottom: "1rem",
        }}
      >
        Coming Soon!
      </h2>

      <p style={{ marginBottom: 0 }}>
        ABA Provider Resources are currently in development.
      </p>
    </div>
  </div>
)}
    </header>
  );
}

export default Navbar;